<template>
  <v-dialog style="z-index: 99998" v-model="value" max-width="500">
    <v-card>
      <v-card-title class="headline">Изменить заблаговременности</v-card-title>

      <v-card-text>
        <v-row>
          <v-col cols="12" md="4">
            <v-text-field
              v-model.number="from"
              class="mx-4"
              label="От - мин"
              max="50"
              min="0"
              step="1"
              style="width: 125px"
              type="number"
            ></v-text-field>
          </v-col>

          <v-col cols="12" md="4">
            <v-text-field
              v-model.number="to"
              class="mx-4"
              label="До - мин"
              max="50"
              min="0"
              step="1"
              style="width: 125px"
              type="number"
            ></v-text-field>
          </v-col>

          <v-col cols="12" md="4">
            <v-text-field
              v-model.number="step"
              class="mx-4"
              label="Шаг - мин"
              max="50"
              min="0"
              step="1"
              style="width: 125px"
              type="number"
            ></v-text-field>
          </v-col>
        </v-row>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>

        <v-btn color="green darken-1" text @click="successHandler">Сохранить</v-btn>

        <v-btn color="green darken-1" text @click="closeHandler">Отмена</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import Predict from "../models/predict";

export default {
  name: "WapiChangeDefaultPredicts",
  props: {
    value: Boolean,
    predicts: [],
    text: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      from: 0,
      to: 0,
      step: 0
    };
  },
  methods: {
    successHandler() {
      if (this.from >= this.to || this.step <= 0) {
        this.$store.dispatch(
          "PUSH_ERROR_MESSAGE",
          "Интервал должен быть больше 0"
        );
        return;
      }

      const result = [];
      for (let index = this.from; index <= this.to; index = index + this.step) {
        const predict = new Predict();
        predict.value = index;
        predict.checked = false;
        result.push(predict);
      }

      this.$emit("change", result);
    },
    closeHandler() {
      this.$emit("input", false);
    }
  }
};
</script>